<div class="customer">
    @if (customerDetails()?.firstName || customerDetails()?.lastName) {
        <div class="customer-name">
            {{ customerDetails().firstName }} {{ customerDetails().lastName }}
        </div>
    }
    @if (customerDetails()?.email) {
        <div class="customer-contact-details">
            {{ customerDetails().email }}
        </div>
    }
    @if (authenticatedCustomerContactDetails()?.email && authenticatedCustomerContactDetails()?.email !== customerDetails()?.email) {
        <div class="customer-contact-details">
            {{ authenticatedCustomerContactDetails().email }}
        </div>
    }
    @if (customerDetails()?.mobilePhone) {
        <div class="customer-contact-details">
            {{ customerDetails().mobilePhone }}
        </div>
    }
    @if (authenticatedCustomerContactDetails()?.mobilePhone && authenticatedCustomerContactDetails()?.mobilePhone !== customerDetails()?.mobilePhone) {
        <div class="customer-contact-details">
            {{ authenticatedCustomerContactDetails().mobilePhone }}
        </div>
    }
</div>
